import { render } from "./TabelaBugs.vue?vue&type=template&id=358409fa"
import script from "./TabelaBugs.vue?vue&type=script&scoped=true&lang=js"
export * from "./TabelaBugs.vue?vue&type=script&scoped=true&lang=js"

import "./TabelaBugs.vue?vue&type=style&index=0&id=358409fa&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__